import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, Input, Tooltip } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { Spin } from 'antd';

const { Option } = Select;
let tenantId = "";
let errorMessage = "";
let commonParamater = "";
let messageCode = "";
let formRef;

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export class NovaEHRPush extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            tenantId: "",
            commonParamater: ""
        }
    };

    formRef = React.createRef();

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        messageCode = urlParams.get("messageCode");

        
        if (!commonParamater) {
            this.setState({ errorMessage: "参数错误，请重试！", isLoading: false, isReady: true });
            return;
        }

        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.loadPage(tenantId, commonParamater);
          
        //this.setState({ isLoading: false, isReady: true, errorMessage: "参数错误，请重试！" }); 
        //this.loadPage(430585, "1246375d-34e8-4a0d-897d-613010ccf01d");
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }

        //EHR Push https://service-bridge.recruit.italent.cn
        axios
            .get("/api/Novastar/PushDataToKayangAsync", { params: params })
            .then(res => {
                if (res.status == 200 && res.data.code == "200") {
                    this.setState({ isLoading: false, isReady: true, errorMessage: "" });
                }
                else {
                    this.setState({ isLoading: false, isReady: true, errorMessage: res.message });
                }
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    onFinish = async (values) => { };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (
                    <div style={{ marginTop: '20px' }}>
                        <Spin spinning={false}>
                            <Alert
                                message="EHR推送-失败"
                                description={this.state.errorMessage}
                                type="error"
                                showIcon
                            />
                        </Spin>
                    </div>
                );
            }
            else {
                return (
                    <div style={{ marginTop: '20px' }}>
                        <Spin spinning={false}>
                            <Alert
                                message="EHR推送-成功"
                                description="EHR推送成功"
                                type="success"
                                showIcon
                            />
                        </Spin>
                    </div>
                );
            }
        }
        else {
            return (
                <div style={{ marginTop: '20px' }}>
                    <Spin spinning={true}>
                        <Alert
                            message="EHR推送-推送中"
                            description="正在推送EHR"
                            type="info"
                            showIcon
                        />
                    </Spin>
                </div>
            );
        }
    }
}